import { WorkExperience } from "./WorkExperience";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { SheetSectionEmptyText } from "@/components/SheetSectionEmptyText";
import { SheetSectionHeader } from "@/components/SheetSectionHeader";
import { cn } from "@/lib/utils";
import { ClassifiedKeyword, WorkExperienceType } from "@/types";

export const WorkExperienceSheetContent = ({
  highlightKeywords,
  workExperiences,
  title,
  className,
}: {
  highlightKeywords?: ClassifiedKeyword[];
  workExperiences: WorkExperienceType[];
  title: string;
  className: string;
}) => {
  const renderContent = () => {
    if (!workExperiences.length) {
      return (
        <SheetSectionEmptyText text="This candidate hasn't yet filled out their work experience." />
      );
    }

    return (
      <Column className="gap-5">
        {workExperiences.map((workExperience) => (
          <WorkExperience
            highlightKeywords={highlightKeywords}
            key={workExperience.id}
            workExperience={workExperience}
          />
        ))}
      </Column>
    );
  };

  return (
    <Column className={cn("gap-6 pb-6 pt-0", className && className)}>
      <Row className={cn("items-center justify-between")}>
        <SheetSectionHeader title={title} />
      </Row>
      {renderContent()}
    </Column>
  );
};
